import { request2, request1 } from './request'
//全校出勤雷达统计报表
export function AttendanceMonitoringMap(date) {
    return request1({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/AttendanceMonitoringMap',
        method: 'get',
        params: {
            dt:date
        }
    })
}

// 班级上课出勤雷达统计报表
export function ClassAttendanceRadarChart(params,isShowGrade) {
    return request1({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/ClassAttendanceRadarChart',
        method: 'get',
        params: {
            dt: params.dt,
            gradeId:params.gradeId,
            isShowGrade:isShowGrade,
            dailyScheduleId:params.dailyScheduleId
        }
    })
}
// 获取指定时间的今日开课班级列表
export function DailySchedulelist(dt) {
    return request1({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/DailySchedulelist',
        method: 'get',
        params: {
            dt: dt,
        }
    })
}

// 燃爆课堂右下角统计
export function GetGradeExamData(params) {
    return request1({
        url: '/api2/TZsbWebProductApi/Sheet/GetGradeExamData',
        method: 'get',
        params: {
            gradeId:params.gradeId
        }
    })
}

//上岸打榜秀统计报表1
export function AttendanceMonitoringMapV2_1(date) {
    return request1({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/AttendanceMonitoringMapV2_1',
        method: 'get',
        params: {
            dt:date
        }
    })
}
//上岸打榜秀统计报表2
export function AttendanceMonitoringMapV2_2(date) {
    return request1({
        url: '/api2/TZsbWebTeachApi/TeachingStatistics/AttendanceMonitoringMapV2_2',
        method: 'get',
        params: {
            dt:date
        }
    })
}